import { render, staticRenderFns } from "./LadTableSet.vue?vue&type=template&id=24ee0850&"
import script from "./LadTableSet.vue?vue&type=script&lang=js&"
export * from "./LadTableSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports